import { counterpartyInsolvencyTooltip } from "helpers/bid";
import { ymEvent } from "helpers/system";
import React, { useState } from "react";
import { getItem, getOrganizationSuggestions } from "sources/books/admin/counterpartiesInsolvencyRegistry";

export default function CheckCounterparty(props) {
    const [value, setValue] = useState("");
    const [loading, setLoading] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const [data, setData] = useState([]);

    const check = (e) => {
        e.preventDefault();
        ymEvent("CounterpartyCheckSearch");
        setLoading(true);
        setLoaded(false);
        setData([]);
        getOrganizationSuggestions(value).then((res) => {
            if (res?.suggestions?.length > 0) {
                const reqs = [];
                res.suggestions.forEach((item) => {
                    reqs.push(getItem(item.inn));
                });
                Promise.all(reqs).then((responses) => {
                    setData(
                        res.suggestions.map((suggestion, i) => ({
                            ...suggestion,
                            insolvencyData: responses[i],
                        })),
                    );
                    setLoaded(true);
                    setLoading(false);
                });
            } else {
                setLoading(false);
                setLoaded(true);
            }
        });
    };

    return (
        <>
            <form className={loading ? "loading" : ""} onSubmit={check}>
                <div className="form-group">
                    <label className="col-form-label col-form-label-sm">Введите ИНН или наименование контрагента</label>
                    <input
                        required
                        name="inn"
                        value={value}
                        className="form-control form-control-sm"
                        onChange={(e) => setValue(e.target.value)}
                    />
                </div>
                <button type="submit" className="btn btn-sm btn-brand">
                    Проверить
                </button>
            </form>
            {loaded &&
                (data?.length === 0 ? (
                    <h5 className="text-center py-4">Ничего не найдено</h5>
                ) : (
                    <table className="table table-sm mt-4">
                        <thead>
                            <tr>
                                <th />
                                <th>Наименование</th>
                                <th>ИНН</th>
                                <th>Статус в реестре CARGO.RUN</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item, i) => (
                                <tr key={i}>
                                    <td>{i + 1}</td>
                                    <td>{item.displayName}</td>
                                    <td>{item.inn}</td>
                                    <td>
                                        {item.insolvencyData
                                            ? counterpartyInsolvencyTooltip(item.insolvencyData, props.add)
                                            : "Отсутствует в реестре"}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                ))}
        </>
    );
}
